export default ({ request }) => ({
  factoryUserOptsList (data = {}) {
    return request({
      url: '/factory/user/list/opts',
      method: 'post',
      data
    })
  },
  sysUserList(data = {}) {
    return request({
      url: '/sys/user/list',
      method: 'post',
      data
    })
  }
})
